import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class SharedToasterService {

    constructor(
        private translocoService: TranslocoService,
        private toastrService: ToastrService
    ) { }


    // general error messages

    public showGeneralError(): void {
        this.toastrService.error(this.translocoService.translate('shared.toastrNotifications.error.general'));
    }

    public showGeneralSavingError(): void {
        this.toastrService.error(this.translocoService.translate('shared.toastrNotifications.error.saving'));
    }

    public showGeneralDataLoadingError(): void {
        this.toastrService.error(this.translocoService.translate('shared.toastrNotifications.error.dataLoading'));
    }

    // general success messages

    public showGeneralSuccess(): void {
        this.toastrService.success(this.translocoService.translate('shared.toastrNotifications.success.general'))
    }

    public showGeneralSavingSuccess(): void {
        this.toastrService.success(this.translocoService.translate('shared.toastrNotifications.success.saving'))
    }

    // emailing

    public showGeneralEmailSendingSuccess(): void {
        this.toastrService.success(this.translocoService.translate('shared.toastrNotifications.success.emailSending'));
    }

    public showGeneralEmailSendingError(): void {
        this.toastrService.error(this.translocoService.translate('shared.toastrNotifications.error.emailSending'));
    }

    // downloading
    public showGeneralDownloadingSuccess(): void {
        this.toastrService.success(this.translocoService.translate('shared.toastrNotifications.success.downloading'));
    }

    public showGeneralDownloadingError(): void {
        this.toastrService.error(this.translocoService.translate('shared.toastrNotifications.error.downloading'));
    }
}
